// extracted by mini-css-extract-plugin
module.exports = {"container":"ModalHeader_container__3Zakj","header":"ModalHeader_header__1hnZe","content":"ModalHeader_content__3RRko","button":"ModalHeader_button__1fESN"};